export default __webpack_public_path__ + "static/media/Surveys_Chats.adbb8090.svg";